"use client";

import {
  AuthError,
  AuthErrorMessages,
  AuthSuccess,
  AuthSuccessMessages,
} from "@/lib/errors";
import { logger } from "@/lib/logger";
import { useQueryState } from "nuqs";
import { useEffect } from "react";
import { toast } from "sonner";

export function ToastListener() {
  const [message, setMessage] = useQueryState("message", {
    defaultValue: "",
    clearOnDefault: true,
  });
  const [error, setError] = useQueryState("error", {
    defaultValue: "",
    clearOnDefault: true,
  });
  const [verified, setVerified] = useQueryState("verified", {
    defaultValue: "",
    clearOnDefault: true,
  });

  useEffect(() => {
    if (message) {
      // Convert enum constant to display message
      const displayMessage =
        message in AuthSuccess
          ? AuthSuccessMessages[message as AuthSuccess]
          : message;
      toast.success(displayMessage);
      setMessage(null);
    }
  }, [message, setMessage]);

  useEffect(() => {
    if (error) {
      logger("[ToastListener] Error", error);
      // Convert enum constant to display message
      const displayError =
        error in AuthError ? AuthErrorMessages[error as AuthError] : error;
      toast.error(displayError);
      setError(null);
    }
  }, [error, setError]);

  useEffect(() => {
    if (!verified) return;

    if (verified === "1") {
      toast.success("Email verified. Thanks for confirming your address.");
    } else {
      toast.error(
        "Confirmation link expired or invalid. Please request a new confirmation email from your profile.",
      );
    }

    setVerified(null);
  }, [verified, setVerified]);

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const params = new URLSearchParams(hash.substring(1));
    const errorParam = params.get("error");
    const errorCode = params.get("error_code");
    const errorDescription = params.get("error_description");

    if (
      errorParam === "access_denied" &&
      errorCode === "otp_expired" &&
      errorDescription
    ) {
      logger("[ToastListener] OTP expired error", errorDescription);
      toast.error(errorDescription);

      // Remove the error params from the hash
      params.delete("error");
      params.delete("error_code");
      params.delete("error_description");

      const newHash = params.toString();
      const newUrl = `${window.location.pathname}${window.location.search}${
        newHash ? `#${newHash}` : ""
      }`;

      window.history.replaceState(null, "", newUrl);
    }
  }, []);

  return null;
}
